/**
 * Matching the RegistrationDTO in the API
 */
import { JobGrade, JobSpeciality } from '@/types/jobs';

export type RegisteredOrganization = 'AHPRA' | 'MCNZ' | 'Other';

export type RegistrationInformation = {
  grade?: JobGrade;
  speciality?: JobSpeciality;
  registeredOrg?: string;
  registrationNumber?: string;
  graduationDate?: string;
  countryOfPrimaryDegree?: string;
  countryOfTraining?: string;
  countriesWorkedIn?: string[];
  preferredWorkLocation?: string;
  preferredAvailability?: string;
  preferredWorkType?: string;
  proposedReferred?: string;
  acceptedTermsConditionsVersion?: number;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  subscriptions: string[];
  redirectUrl?: string;
  specialityTextarea?: string;
  gaClientId?: string;
  referralCode?: string;
  whitepaperName?: string;
};

export type OnboardingInformation = Omit<RegistrationInformation, 'password'>;

export const DefaultRegisterForm = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  phone: '',
  phoneArea: '',
  grade: '',
  speciality: { key: '', value: '' },
  specialityTextarea: '',
  countryOfPrimaryDegree: { key: '', value: '' },
  graduationDate: undefined,
  registeredOrg: '',
  countryOfTraining: { key: '', value: '' },
  countriesWorkedIn: [],
  preferredWorkLocation: { key: '', value: '' },
  proposedReferred: '',
  subscriptions: [],
  preferredAvailability: { key: '', value: '' },
  preferredWorkType: { key: '', value: '' },
  registrationNumber: '',
  referralCode: '',
};

export interface KeypairProps {
  key: string;
  value: string;
}
// Typescript complains about the data-testid type on the Checkbox inputprops
// see https://github.com/mui/material-ui/issues/18874 and https://github.com/microsoft/TypeScript/issues/28960
export interface RegistrationCheckboxInputProps extends React.HTMLAttributes<HTMLDivElement> {
  'data-testid'?: string;
}

export type PreferredWorkLocation =
  | {
      key: 'Australia';
      value: 'Anywhere in Australia';
    }
  | {
      key: 'New Zealand';
      value: 'Anywhere in New Zealand';
    }
  | {
      key: 'Either';
      value: 'Either Australia or New Zealand';
    }
  | {
      key: 'Victoria Australia';
      value: 'Victoria Australia';
    }
  | {
      key: 'New South Wales Australia';
      value: 'New South Wales Australia';
    }
  | {
      key: 'Queensland Australia';
      value: 'Queensland Australia';
    }
  | {
      key: 'South Australia';
      value: 'South Australia';
    }
  | {
      key: 'Australian Capital Territory';
      value: 'Australian Capital Territory';
    }
  | {
      key: 'Tasmania Australia';
      value: 'Tasmania Australia';
    }
  | {
      key: 'Western Australia';
      value: 'Western Australia';
    }
  | {
      key: 'North Island of New Zealand';
      value: 'North Island of New Zealand';
    }
  | {
      key: 'South Island of New Zealand';
      value: 'South Island of New Zealand';
    }
  | {
      key: 'Northern Territory Australia';
      value: 'Northern Territory Australia';
    };
